import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "AppointmentReport.AppointmentReportGridContainer.title",
    defaultMessage: "Reports",
  },
  btnResendReports: {
    id: "AppointmentReport.AppointmentReportGridContainer.btnResendReports",
    defaultMessage: "Resend Reports",
  },
});
